import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import './GallerySection.css';

const GallerySection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const galleryImages = [
    {
      src: '/images/Custom Interior Lighting.jpg',
      title: 'Custom Interior Lighting',
      category: 'Interior Design'
    },
    {
      src: '/images/Table and Chairs.jpg',
      title: 'Dining Table & Chairs',
      category: 'Furniture'
    },
    {
      src: '/images/Table Tennis Court Interior.jpg',
      title: 'Table Tennis Court Interior',
      category: 'Commercial'
    },
    {
      src: '/images/Hotel and Restaurant Interior Design 1.jpg',
      title: 'Hotel & Restaurant Interior',
      category: 'Commercial'
    },
    {
      src: '/images/Hotel Lobby Interior Design.jpg',
      title: 'Hotel Lobby Design',
      category: 'Commercial'
    },
    {
      src: '/images/Kitchen Drawers.jpg',
      title: 'Modular Kitchen Drawers',
      category: 'Kitchen'
    },
    {
      src: '/images/livingroom2.jpg',
      title: 'Modern Living Room',
      category: 'Interior Design'
    },
    {
      src: '/images/jmjbeds.jpg',
      title: 'Custom Bedroom Design',
      category: 'Furniture'
    }
  ];

  const openLightbox = (image, index) => {
    setSelectedImage(image);
    setCurrentIndex(index);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const nextImage = () => {
    const nextIndex = (currentIndex + 1) % galleryImages.length;
    setCurrentIndex(nextIndex);
    setSelectedImage(galleryImages[nextIndex]);
  };

  const prevImage = () => {
    const prevIndex = (currentIndex - 1 + galleryImages.length) % galleryImages.length;
    setCurrentIndex(prevIndex);
    setSelectedImage(galleryImages[prevIndex]);
  };

  return (
    <section id="gallery" className="section gallery-section">
      <div className="container">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="section-title"
        >
          <h2>Our Portfolio</h2>
          <p>
            Explore our stunning collection of interior design projects and custom furniture creations.
          </p>
        </motion.div>

        <div className="gallery-grid">
          {galleryImages.map((image, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={inView ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="gallery-item"
              onClick={() => openLightbox(image, index)}
            >
              <img src={image.src} alt={image.title} />
              <div className="gallery-overlay">
                <div className="gallery-info">
                  <h3>{image.title}</h3>
                  <p>{image.category}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {selectedImage && (
          <div className="lightbox" onClick={closeLightbox}>
            <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
              <button className="lightbox-close" onClick={closeLightbox}>
                <X size={24} />
              </button>
              <button className="lightbox-prev" onClick={prevImage}>
                <ChevronLeft size={24} />
              </button>
              <button className="lightbox-next" onClick={nextImage}>
                <ChevronRight size={24} />
              </button>
              <img src={selectedImage.src} alt={selectedImage.title} />
              <div className="lightbox-info">
                <h3>{selectedImage.title}</h3>
                <p>{selectedImage.category}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default GallerySection;